<template>
    <div class="bg-wrap">
        <Banner></Banner>
        <div class="content">
            <label>项目即将进入劳务支付流程</label>
            <label>请您填写账户信息</label>
        </div>
        <div class="info">
            <ul>
                <li>
                    <span>户名:</span>
                    <input type="text" v-model="accountName">
                </li>
                <li>
                    <span>账号:</span>
                    <input type="text" v-model="accountNumber">
                </li>
                <li style="margin-bottom: 0">
                    <span>开户行:</span>
                    <input type="text" v-model="accountBank">
                </li>
                <label class="label">请具体到您的支行信息，如果填写不清，将影响您的劳务费指出</label>
                <li>
                    <span>手机号:</span>
                    <input type="text" v-model="phone">
                </li>
                <li>
                    <span>身份证号:</span>
                    <input type="text" v-model="id">
                </li>
            </ul>
        </div>
        <div class="submit" @click="toSubmit">
            <span>声明：以上所填信息仅用于本次支付劳务费用使用</span>
            <label>提交</label>
        </div>
    </div>

</template>

<script>
    import Banner from "@/components/ksd/fragment/Banner";
    import {ksdAddJudgeAccount,ksdGetJudgeAccount} from "@/assets/js/api";

    export default {
        name: "JudgeLogin",
        data(){
            return{
                judgeId:this.$store.state.ksd_judgeId,
                accountName:"",
                accountNumber:"",
                accountBank:"",
                phone:"",
                id:""
            }
        },
        methods:{
            toSubmit(){
                if(this.accountName==""){
                    this.$toast("请填写户名")
                    return
                }if(this.accountNumber==""){
                    this.$toast("请填写账号")
                    return;
                }if(this.accountBank==""){
                    this.$toast("请填写开户行")
                    return;
                }if(this.phone==""){
                    this.$toast("请填写手机号")
                    return;
                }if(this.id==""){
                    this.$toast("请填写身份证号")
                    return
                }
                this.submit(this.judgeId,this.accountName,this.accountNumber,this.accountBank,this.phone,this.id)
            },
            async getAccount(judgeId){
              const res =  await ksdGetJudgeAccount({judgeId})
                if(res.data.data!=null&&res.data.data!=""){
                    this.accountNumber = res.data.data.accountNumber
                    this.accountName = res.data.data.accountName
                    this.accountBank = res.data.data.accountBank
                    this.phone = res.data.data.phone
                    this.id = res.data.data.id
                }
                console.log(res,"getAccount")
            },
            async submit(judgeId,accountName,accountNumber,accountBank,phone,id){
                const res = await ksdAddJudgeAccount({judgeId,accountName,accountNumber,accountBank,phone,id})
                if(res.data.success){
                    this.$router.push("judgeCase")
                }else{
                    this.$toast(res.data.message)
                }

                console.log(res,"addAccount")
            }
        },
        components:{
            Banner
        },
        mounted(){
            this.getAccount(this.judgeId)
        }
    }
</script>

<style scoped lang="scss">
    .bg-wrap {
        width: 100%;
        height: 100vh;
        background: transparent url("https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/bg.png") no-repeat;
        background-size: 100% 100%;
        /*display: flex;*/
        /*flex-flow: column;*/
        overflow: scroll;
        font-size: 14px;
        font-weight: bold;
        overflow: scroll;
    }
    .bottom{
        display: flex;
        justify-content: flex-end;
        margin-bottom: -50px;
        img{
            width: 350px;
            height: 344px;
        }
    }
    .content{
        width: 100%;
        display: flex;
        flex-flow: column;
        justify-content: center;
        align-items: center;
        label{
            font-size: 18px;
            color: #156098;
            margin-bottom: 5px;
        }
    }

    ul{
        width: 80%;
        margin: 0 auto;
        padding: 0;
    }
    ul li{
        width: 100%;
        list-style: none;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        background: #E6E6E6;
        padding: 5px 0;
        margin: 10px 0;
        font-size: 14px;
        border-radius: 5px;
        span{
            margin-left: 10px;
            white-space: nowrap;
        }
        input{
            text-indent: 10px;
            flex-grow: 1;
            background: transparent;
            border: none;
            outline: none;
            font-size: 16px;
        }
    }
    .label{
        display: block;
        color: #C30D23;
        text-align: left;
        font-size: 10px;
    }
    .submit{
        width: 90%;
        margin: 20px auto;
        span{
            display: block;
            font-size: 12px;
            text-align: left;
            opacity: 0.5;
            margin-left: 10px;
        }
        label{
            display: block;
            width: 100%;
            background: #156098;
            padding: 5px 0;
            color: #FFF;
            border-radius: 5px;
            margin-top: 2px;
        }
    }
</style>